<template>
  <section>
    <h2 class="my-3 display-2">Elections</h2>

    <v-data-table :headers="headers" :items="elections" class="mt-5 elevation-1" hide-default-footer
      loading-text="Loading... Please wait" :footer-props="tableFooterProps">
      <template v-slot:[`item.created_at`]="{ item }">
        <span style="white-space: nowrap">{{ timeago(item.created_at) }}</span>
      </template>
      <template v-slot:[`item.association.description`]="{ item }">
        <span> {{ item.association.description }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span class="text-uppercase"> {{ item.status }}</span>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span style="white-space: nowrap; line-height: 1;">
          {{ formatDateOnly(item.date) }}
          <small style="display: block;">{{ formatTime(item.start) }} &mdash; {{ formatTime(item.end) }}</small>
        </span>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-btn small depressed color="brown lighten-3" :to="`/elections/${item.id}`">
          More Info
        </v-btn>
      </template>
    </v-data-table>
  </section>
</template>


<script>
import { timeago, formatDateOnly } from "../../tools/format";
export default {
  data: () => ({
    elections: [],
    headers: [
      {
        text: "Created",
        align: "start",
        sortable: false,
        value: "created_at",
      },
      { text: "Association", value: "association.description" },
      { text: "Session", value: "session.sSesName" },
      { text: "Status", value: "status" },
      { text: "Voters", value: "voters" },
      { text: "Date", value: "date" },
      // { text: "Start", value: "start" },
      // { text: "End", value: "end" },
      { text: "Actions", value: "id", sortable: false },
    ],
    tableFooterProps: {
      itemsPerPageOptions: [-1],
    },
    meta: {
      total: 0,
      last_page: 0,
      current_page: 0,
    },

    query: null,
  }),

  methods: {
    timeago,
    formatTime(time) {
      return time.substr(0, 5);
    },
    formatDateOnly,
    loadElections() {
      this.$axios.get("/elections").then(async ({ data: elections }) => {
        this.elections = elections;
      });
    },
  },

  mounted() {
    this.loadElections();
  },
};
</script>
